import { render } from "./CommitmentsCertif.vue?vue&type=template&id=09020c3c&scoped=true"
const script = {}

import "./CommitmentsCertif.vue?vue&type=style&index=0&id=09020c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09020c3c"]])

export default __exports__